"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateObject = void 0;
const constants_1 = require("./constants");
const getSerializedObjectSize_1 = require("./getSerializedObjectSize");
const getStringSize_1 = require("./getStringSize");
const invariant_1 = require("./invariant");
function truncateObject(obj, truncators, sizeLimit, options = {}) {
    (0, invariant_1.invariant)(Array.isArray(truncators), 'Expect trucators to be an array');
    (0, invariant_1.invariant)(Number.isInteger(sizeLimit), 'Expeect sizeLimit to be an integer');
    const { escapedChars } = options;
    const serializedObjectSize = (0, getSerializedObjectSize_1.getSerializedObjectSize)(obj, options);
    const [truncator, ...truncatorsRest] = truncators;
    const stopCondition = sizeLimit < (0, getStringSize_1.getStringSize)(constants_1.ELLIPSIS_CHAR, { escapedChars }) ||
        serializedObjectSize <= sizeLimit ||
        typeof truncator !== 'function';
    if (stopCondition && serializedObjectSize > sizeLimit) {
        throw new Error(`object size exceed limit after truncation [${serializedObjectSize} B > ${sizeLimit} B]`);
    }
    return stopCondition
        ? obj
        : truncateObject(truncator(obj, serializedObjectSize - sizeLimit), truncatorsRest, sizeLimit, options);
}
exports.truncateObject = truncateObject;
//# sourceMappingURL=truncateObject.js.map